module.exports = __webpack_public_path__ + "static/media/L Nadine H.e81606ed.png";